import { applicationModuleRegistry } from '@philips-emr/tws-foundation';

import { Route } from '../../route';

export function registerCalls(): void {
  applicationModuleRegistry.register({
    entry: 'calls',
    id: 'calls',
    name: 'provider.calls',
    route: Route.CALLS,
    order: 2,
    closeable: true,
  });
}
